var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNextPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.7253 2.2253C6.02571 1.9249 6.51276 1.9249 6.81316 2.2253L16.0439 11.4561C16.3443 11.7565 16.3443 12.2435 16.0439 12.5439L6.81316 21.7747C6.51276 22.0751 6.02571 22.0751 5.7253 21.7747C5.4249 21.4743 5.4249 20.9872 5.7253 20.6868L14.4121 12L5.7253 3.31316C5.4249 3.01276 5.4249 2.52571 5.7253 2.2253Z",
    fill: "#2362A2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextPage);
export default __webpack_public_path__ + "static/media/next_page.9a9ecf874e836d2f6554db283744d1c0.svg";
export { ForwardRef as ReactComponent };